import { decode } from "../queryEncryption";

const base64regex = /^[A-Za-z0-9+/=]+$/;

const getValue = (value) => {
    try {
        return base64regex?.test(value) ? decode(value) : value;
    } catch (error) {
        return value;
    }
};

export const getFormData = (value) => {
    return {
        id: value?.id,
        smtpName: value?.smtpName,
        smtpHost: getValue(value?.smtpHost),
        smtpPort: getValue(value?.smtpPort),
        smtpEmail: getValue(value?.smtpEmail),
        smtpSender: getValue(value?.smtpSender),
        smtpSenderEmail: getValue(value?.smtpSenderEmail),
        smtpPassword: getValue(value?.smtpPassword),
        isActive: value?.isActive
    };
};